var _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconCar30 = function SvgAIconCar30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 12L23.4351 6.6712C23.0545 5.66487 22.0829 4.9986 20.998 5H9.00105C7.91619 4.9986 6.94458 5.66487 6.56398 6.6712L4.5 12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0856 8.00001L19.915 8C20.3423 8 20.7224 8.27157 20.861 8.67585L22 12H8L9.13963 8.67572C9.2782 8.27151 9.65829 8.00001 10.0856 8.00001Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21V22.7703C3 23.7276 3.7835 24.5036 4.75 24.5036C5.7165 24.5036 6.5 23.7276 6.5 22.7703V21.037",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21V22.7703C27 23.7276 26.2165 24.5036 25.25 24.5036C24.2835 24.5036 23.5 23.7276 23.5 22.7703V21.037",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31111 12C3.03472 12 2 13.0582 2 14.3636V19.8182C2 20.4709 2.51736 21 3.15556 21H26.8444C27.4826 21 28 20.4709 28 19.8182V14.3636C28 13.0582 26.9653 12 25.6889 12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 16,
    r: 1.5,
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 16,
    r: 1.5,
    strokeWidth: 1.5
  })));
};
export { SvgAIconCar30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0yNS40OTk5IDEyTDIzLjQzNTEgNi42NzEyQzIzLjA1NDUgNS42NjQ4NyAyMi4wODI5IDQuOTk4NiAyMC45OTggNUg5LjAwMTA1QzcuOTE2MTkgNC45OTg2IDYuOTQ0NTggNS42NjQ4NyA2LjU2Mzk4IDYuNjcxMkw0LjUgMTIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xMC4wODU2IDguMDAwMDFMMTkuOTE1IDhDMjAuMzQyMyA4IDIwLjcyMjQgOC4yNzE1NyAyMC44NjEgOC42NzU4NUwyMiAxMkg4TDkuMTM5NjMgOC42NzU3MkM5LjI3ODIgOC4yNzE1MSA5LjY1ODI5IDguMDAwMDEgMTAuMDg1NiA4LjAwMDAxWiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTMgMjFWMjIuNzcwM0MzIDIzLjcyNzYgMy43ODM1IDI0LjUwMzYgNC43NSAyNC41MDM2QzUuNzE2NSAyNC41MDM2IDYuNSAyMy43Mjc2IDYuNSAyMi43NzAzVjIxLjAzNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTI3IDIxVjIyLjc3MDNDMjcgMjMuNzI3NiAyNi4yMTY1IDI0LjUwMzYgMjUuMjUgMjQuNTAzNkMyNC4yODM1IDI0LjUwMzYgMjMuNSAyMy43Mjc2IDIzLjUgMjIuNzcwM1YyMS4wMzciIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik00LjMxMTExIDEyQzMuMDM0NzIgMTIgMiAxMy4wNTgyIDIgMTQuMzYzNlYxOS44MTgyQzIgMjAuNDcwOSAyLjUxNzM2IDIxIDMuMTU1NTYgMjFIMjYuODQ0NEMyNy40ODI2IDIxIDI4IDIwLjQ3MDkgMjggMTkuODE4MlYxNC4zNjM2QzI4IDEzLjA1ODIgMjYuOTY1MyAxMiAyNS42ODg5IDEyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8Y2lyY2xlIGN4PSI2LjUiIGN5PSIxNiIgcj0iMS41IiBzdHJva2Utd2lkdGg9IjEuNSIgLz4KPGNpcmNsZSBjeD0iMjMuNSIgY3k9IjE2IiByPSIxLjUiIHN0cm9rZS13aWR0aD0iMS41IiAvPgo8L3N2Zz4=";